enum NylasType {
  CALENDAR = "calendar",
  EMAIL = "email",
}

export default NylasType;
